import React from 'react'
import { Box, Typography, Card, CardContent, CircularProgress, useTheme } from '@mui/material'

export const QualityAssignmentLoadingCard: React.FC = () => {
  const theme = useTheme()

  return (
    <Box mb={3}>
      <Card
        variant="outlined"
        style={{
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper
        }}
      >
        <CardContent>
          <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
            <CircularProgress size={40} style={{ marginBottom: theme.spacing(2) }} />
            <Typography variant="h6" gutterBottom style={{ color: theme.palette.text.primary, textAlign: 'center' }}>
              Asignando posición de calidad
            </Typography>
            <Typography variant="body2" style={{ color: theme.palette.text.secondary, textAlign: 'center' }}>
              El producto está vencido o por vencer. Obteniendo posición de CALIDAD-TRANSFERENCIA...
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}
